/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { FC, memo } from 'react';
import cn from 'classnames';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import { animated } from 'react-spring';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import css from './styles.module.scss';
import ScreenshotNotification from './components/ScreenshotNotification';
import BatchDownloadNotification from './components/BatchDownloadNotification';
import {
  IFormattedNotification,
  isMarkTypeHasData,
  isMassCreativeCreateTypeHasData,
  isScreenshotTypeHasData,
} from './types';
import { useNotificationItem } from './hooks/useNotificationItem';
import MarkNotification from './components/MarkNotification';

type Props = {
  notification: IFormattedNotification;
  markAsRead: (id: number) => void;
  markAsReadAndRemove: (id: number) => void;
  handleGetTask: (task_id: number) => void;
};

const NotificationItem: FC<Props> = ({
  notification,
  markAsRead,
  markAsReadAndRemove,
  handleGetTask,
}) => {
  const { t } = useTranslation();
  const { notification_id, date, type, is_read } = notification;

  const { style, handleMarkAsRead } = useNotificationItem({
    markAsRead,
    markAsReadAndRemove,
    notification_id,
    is_read,
  });

  const renderContent = () => {
    switch (type) {
      case 'screenshot':
        if (!isScreenshotTypeHasData(notification)) return null;
        return (
          <ScreenshotNotification
            notification={notification}
            handleMarkAsRead={handleMarkAsRead}
          />
        );
      case 'mass_creative_create':
        if (!isMassCreativeCreateTypeHasData(notification)) return null;
        return (
          <BatchDownloadNotification
            notification={notification}
            handleMarkAsRead={handleMarkAsRead}
            handleGetTask={handleGetTask}
          />
        );
      case 'mark_url_get':
        if (!isMarkTypeHasData(notification)) return null;
        return (
          <MarkNotification
            notification={notification}
            handleMarkAsRead={handleMarkAsRead}
          />
        );
      default:
        return null;
    }
  };

  const circle = (
    <button
      type="button"
      onClick={handleMarkAsRead}
      disabled={is_read}
      className={cn(css.item__circle, {
        [css.item__circle_read]: is_read,
      })}
    />
  );

  return (
    <animated.div
      style={{
        transform: style.x.to((x) => `translateX(${x}px)`),
        opacity: style.opacity,
        overflow: 'hidden', // чтобы скрыть содержимое при height=0
      }}
      className={cn(css.notification__item, css.item, {
        _isNew: !is_read,
        _isRead: is_read,
      })}
    >
      {is_read ? (
        circle
      ) : (
        <TooltipPoratal hint={t(`markAsRead`)} left>
          {circle}
        </TooltipPoratal>
      )}
      <div className={css.item__info}>
        <div className={css.item__date}>
          {moment(date).format('DD.MM.YYYY HH:mm:ss')}
        </div>
        {renderContent()}
      </div>
    </animated.div>
  );
};

export default memo(NotificationItem);
